import {PWMAT_RESOURCE} from './consts'

export const Case = [
  {
    id:'1.ORR计算文献：',
    paper:'Single-iron  supported on defective graphene as efficient catalysts for oxygen reduction reaction.',
    paper_url:'https://pubs.acs.org/doi/10.1021/acs.jpcc.0c03930',
    name:'a.计算流程说明文档',
    name_url:PWMAT_RESOURCE+'Case_ORR.pdf',
    file_name:'Case_ORR.pdf',
    inputfile:'b.计算输入文件',
    inputfile_url:PWMAT_RESOURCE+'Case_ORR.tar.gz',
    inputfile_name:'Case_ORR.tar.gz'
  },
  {
    id:'2.固定电势法计算文献：',
    paper:'Single-Iron Supported on Defective Graphene as Efficient Catalysts for Oxygen Reduction Reaction.',
    paper_url:'https://pubs.acs.org/doi/10.1021/acs.jpcc.0c03930',
    name:'a.计算流程说明文档',
    name_url:PWMAT_RESOURCE+'Case_ORR-FPM_20220921.pdf',
    file_name:'Case_ORR-FPM_20220921.pdf',
    inputfile:'b.计算输入文件',
    inputfile_url:PWMAT_RESOURCE+'Case_ORR-FPM.tar.gz',
    inputfile_name:'Case_ORR-FPM.tar.gz'
  },
  {
    id:'3.TDDFT方法计算文献：',
    paper:'Impurity diffusion induced dynamic electron donors in semiconductors.',
    paper_url:'https://journals.aps.org/prb/abstract/10.1103/PhysRevB.100.165203',
    name:'a.计算流程说明文档',
    name_url:PWMAT_RESOURCE+'TDDFT-1.杂质扩散与载流子激发.pdf',
    file_name:'TDDFT-1.杂质扩散与载流子激发.pdf',
    inputfile:'b.计算输入文件',
    inputfile_url:PWMAT_RESOURCE+'TDDFT-1.tar.gz',
    inputfile_name:'TDDFT-1.tar.gz'
  },
  {
    id:'4.TDDFT方法计算文献：',
    paper:'Microscopic force driving the photoinduced ultrafast phase transition: Time-dependent density functional theory simulations of IrTe2',
    paper_url:'https://journals.aps.org/prb/abstract/10.1103/PhysRevB.102.184308',
    name:'a.计算流程说明文档',
    name_url:PWMAT_RESOURCE+'TDDFT-2.光致相变.pdf',
    file_name:'TDDFT-2.光致相变.pdf',
    inputfile:'b.计算输入文件',
    inputfile_url:PWMAT_RESOURCE+'TDDFT-2.tar.gz',
    inputfile_name:'TDDFT-2.tar.gz'
  },
  {
    id:'5.TDDFT计算文献：',
    paper:'The critical role of hot carrier cooling in optically excited structural transitions.',
    paper_url:'https://www.nature.com/articles/s41524-021-00582-w',
    name:'a.计算说明文档',
    name_url:PWMAT_RESOURCE+'TDDFT-3.载流子冷却.pdf',
    file_name:'TDDFT-3.载流子冷却.pdf',
    inputfile:'b.计算输入文件',
    inputfile_url:PWMAT_RESOURCE+'TDDFT-3.tar.gz',
    inputfile_name:'TDDFT-3.tar.gz'
  },
  {
    id:'6.NAMD方法计算文献：',
    paper:'Computational discovery of PtS2/GaSe van der Waals heterostructure for solar energy applications.',
    paper_url:'https://pubs.rsc.org/en/content/articlelanding/2021/cp/d1cp02436a',
    name:'a.计算流程说明文档',
    name_url:PWMAT_RESOURCE+'NAMD-1.热载流子冷却.pdf',
    file_name:'NAMD-1.热载流子冷却.pdf',
    inputfile:'b.计算输入文件',
    inputfile_url:PWMAT_RESOURCE+'NAMD-1.热载流子冷却.tar.gz',
    inputfile_name:'NAMD-1.热载流子冷却.tar.gz'
  },
  ]
